if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    getAddonScope() {
      return this.closest('quick-add-modal')
        || this.closest('section[id^="MainProduct-"]')
        || this.closest('[data-section]')
        || this;
    }

    getSelectedAddonItems() {
      const scope = this.getAddonScope();
      const mainVariantId = String(this.form.querySelector('[name="id"]').value);
      const itemsByVariant = new Map();

      scope.querySelectorAll('[data-sw-addon-input]:checked').forEach((input) => {
        if (input.disabled) return;

        const variantId = String(input.dataset.swAddonVariantId || input.value || '').trim();
        if (!variantId || variantId === mainVariantId) return;

        const card = input.closest('[data-sw-addon-card]');
        const quantityInput = card ? card.querySelector('[data-sw-addon-quantity]') : null;
        const quantity = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10) || 1);
        const existingItem = itemsByVariant.get(variantId);

        if (existingItem) {
          existingItem.quantity += quantity;
        } else {
          itemsByVariant.set(variantId, { id: Number(variantId), quantity });
        }
      });

      return Array.from(itemsByVariant.values());
    }

    buildMainItem(formData) {
      const item = {
        id: Number(formData.get('id')),
        quantity: Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1),
      };
      const sellingPlan = formData.get('selling_plan');
      const properties = {};

      if (sellingPlan) item.selling_plan = Number(sellingPlan);

      formData.forEach((value, key) => {
        const propertyMatch = key.match(/^properties\[(.+)\]$/);
        if (propertyMatch && value !== '') properties[propertyMatch[1]] = value;
      });

      if (Object.keys(properties).length) item.properties = properties;
      return item;
    }

    normalizeMultiItemResponse(response) {
      if (!Array.isArray(response.items) || !response.items.length) return response;

      response.id = response.id || response.items[0].id;
      response.key = response.key || response.items[0].key;
      return response;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const formData = new FormData(this.form);
      const mainVariantId = formData.get('id');
      const addonItems = this.getSelectedAddonItems();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      if (addonItems.length) {
        const payload = {
          items: [this.buildMainItem(formData), ...addonItems],
          sections_url: window.location.pathname,
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
        }

        config.body = JSON.stringify(payload);
      } else {
        delete config.headers['Content-Type'];
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          response = this.normalizeMultiItemResponse(response);
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: mainVariantId,
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: mainVariantId });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!window.swProductAddonControlsBound) {
  window.swProductAddonControlsBound = true;

  document.addEventListener('change', (event) => {
    const input = event.target.closest && event.target.closest('[data-sw-addon-input]');
    if (!input) return;

    const card = input.closest('[data-sw-addon-card]');
    if (card) card.classList.toggle('is-selected', input.checked);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-sw-addon-quantity-change]');
    if (!button) return;

    const card = button.closest('[data-sw-addon-card]');
    const quantityInput = card ? card.querySelector('[data-sw-addon-quantity]') : null;
    if (!quantityInput) return;

    const direction = parseInt(button.dataset.swAddonQuantityChange, 10) || 0;
    const minimum = parseInt(quantityInput.min, 10) || 1;
    const maximum = parseInt(quantityInput.max, 10) || 99;
    const current = parseInt(quantityInput.value, 10) || minimum;
    quantityInput.value = Math.min(maximum, Math.max(minimum, current + direction));
  });

  document.addEventListener('change', (event) => {
    const quantityInput = event.target.closest && event.target.closest('[data-sw-addon-quantity]');
    if (!quantityInput) return;

    const minimum = parseInt(quantityInput.min, 10) || 1;
    const maximum = parseInt(quantityInput.max, 10) || 99;
    const current = parseInt(quantityInput.value, 10) || minimum;
    quantityInput.value = Math.min(maximum, Math.max(minimum, current));
  });
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    document.querySelector('footer').classList.add('sticky-cart-modal_bottom_padding');
  }
  update(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const conversionRoot = document.getElementById(`MainProduct-${this.dataset.section}`)?.closest('.product-page-section--conversion');
    const title = conversionRoot?.querySelector('.product__title');
    const addButton = button.querySelector('[name="add"]');
    const triggerElement = title || addButton;
    if (!triggerElement) return;
    const rangeToShowModal = this.getTop(triggerElement) + triggerElement.clientHeight;
    if(window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')){
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if(window.scrollY < rangeToShowModal && this.classList.contains('show-modal')){
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);
